import { Component, OnInit, Input } from '@angular/core';
import { HelperService } from 'src/app/core/services/helper.service';

@Component({
  selector: 'app-course-tutor-card',
  templateUrl: './course-tutor-card.component.html',
  styleUrls: ['./course-tutor-card.component.css']
})
export default class CourseTutorCardComponent implements OnInit {

  @Input() public teacherData = [];

  @Input() dataType: any = null;

  public errImgTry: number = 0;
  public errImgMaxTry: number = 5;

  constructor(
    public _helper: HelperService
  ) {

  }

  ngOnInit(): void {
    console.log(this.teacherData);
  }

}
